<template>
  <div id="mybill">
    <Breadcrumb></Breadcrumb>

    <div class="common-limit line-height-40">
      <div class="form-body">
        <el-form ref="form" :model="form" label-width="80px">
          <el-row :gutter="24">
            <el-col :span="8">
              <el-form-item label="统计维度：" prop="statRange">
                <el-radio-group v-model="form.statRange">
                  <el-radio :label="`account`">账号维度</el-radio
                  ><el-radio :label="`product`">产品维度</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="统计时间：" prop="time">
                <el-date-picker
                  size="small"
                  v-model="dateTime"
                  type="daterange"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  :picker-options="pickerOptions"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="产品类型：" prop="pOperNo">
                <el-select
                  v-model="form.productType"
                  placeholder="请选择产品类型"
                  class="input"
                  size="small"
                  clearable
                >
                  <el-option
                    v-for="(value, index) in dictData['product_type']"
                    :key="index"
                    :label="value.label"
                    :value="value.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="8">
              <el-form-item label="主账号：" prop="pOperNo">
                <el-input size="small" v-model="form.pOperNo"></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="16">
              <el-form-item style="text-align: right" label="" prop="fundType">
                <el-button type="primary" size="small" @click="loadData"
                  >搜索</el-button
                >
                <el-button size="small" @click="resetForm">重置</el-button>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>

    <div class="form-body">
      <div style="overflow: hidden">
        <span style="float: left">
          <el-button
            v-if="false"
            type="primary"
            size="small"
            @click="handleExport"
            >导出</el-button
          >
        </span>
        <pagination
          v-show="total > 0"
          :total="total"
          :page.sync="form.pageNum"
          :limit.sync="form.pageSize"
          @pagination="loadData"
          :layout="'slot, total, sizes, prev, pager, next, jumper'"
        >
        </pagination>
      </div>
      <el-table border :data="tableData">
        <el-table-column align="center" label="排名" prop="rank">
        </el-table-column>
        <el-table-column
          v-if="statRange == 'account'"
          align="center"
          label="主账号"
          prop="pOperNo"
        >
          <template slot-scope="scope">
            {{ scope.row.pOperNo ? scope.row.pOperNo : scope.row.pOperNo }}
          </template>
        </el-table-column>
        <el-table-column
          v-if="statRange == 'product'"
          align="center"
          label="产品名称"
          prop="proName"
        >
        </el-table-column>
        <el-table-column align="center" label="数量" prop="designNum">
        </el-table-column>
        <el-table-column align="center" label="占比" prop="perNum">
          <template slot-scope="scope">
            {{ (scope.row.perNum * 100).toFixed(2) }}%
          </template>
        </el-table-column>
        <el-table-column align="center" label="明细" prop="refundOrderNum">
          <template slot-scope="scope">
            <p>
              <el-button
                type="text"
                size="mini"
                @click="handleShowDetail(scope.row)"
              >
                {{ form.statRange == "account" ? "设计" : "账号" }}
              </el-button>
            </p>
          </template>
        </el-table-column>
      </el-table>
      <pagination
        class="bottom-sticky"
        v-show="total > 0"
        :total="total"
        :page.sync="form.pageNum"
        :limit.sync="form.pageSize"
        @pagination="loadData"
      />
    </div>

    <el-dialog
      :close-on-click-modal="false"
      :title="form.statRange == 'account' ? '设计明细' : '账号明细'"
      :visible.sync="designVisible"
      destroy-on-close
      width="39%"
    >
      <div style="margin: 0 0 8px 0">
        <span v-if="form.statRange == 'account'"
          >账号： {{ currentRow.pOperNo }}</span
        >
        <span v-if="form.statRange == 'product'"
          >产品名称： {{ currentRow.proName }}</span
        >
        <span style="margin: 0 0 0 16px" v-if="form.beginTime"
          >日期：{{ form.beginTime }} ~ {{ form.endTime }}</span
        >
      </div>
      <div>
        <el-table border :data="detailData">
          <el-table-column align="center" label="排名" prop="rank">
          </el-table-column>
          <el-table-column
            v-if="form.statRange == 'account'"
            align="center"
            label="产品名称"
            prop="proName"
          >
            <template slot-scope="scope">
              {{ scope.row.proName }}
            </template>
          </el-table-column>
          <el-table-column
            v-if="form.statRange == 'product'"
            align="center"
            label="账号"
            prop="pOperNo"
          >
            <template slot-scope="scope">
              {{ scope.row.pOperNo }}
            </template>
          </el-table-column>
          <el-table-column align="center" label="数量" prop="designNum">
          </el-table-column>
          <el-table-column align="center" label="占比" prop="perNum">
            <template slot-scope="scope">
              {{ (scope.row.perNum * 100).toFixed(2) }}%
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div slot="footer">
        <el-button @click="designVisible = false" size="small">关 闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex"
import Breadcrumb from "@/components/common/Breadcrumb"
import {
  selectGldStatByAcount,
  selectGldStatByAcountDetail,
  selectGldStatByPro,
  selectGldStatByProDetail,
} from "@/api/order/stats"
import { downLoadExcel } from "@/utils/zipdownload"
import qs from "qs"
import { getShopList } from "@/api/system/shopManage"
import { listMainChild } from "@/api/system/user"

export default {
  name: "Notice",
  components: {
    Breadcrumb,
  },
  data() {
    return {
      // 查询参数
      form: {
        pageNum: 1,
        pageSize: 30,
        pOperNo: "",
        beginTime: undefined,
        endTime: undefined,
        statType: "1",
        statRange: "account",
      },
      dateTime: [],
      weekBegin: "",
      weekEnd: "",
      monthBegin: "",
      monthEnd: "",
      yearBegin: "",
      yearEnd: "",
      loading: false,
      total: 0,
      tableData: [],
      detailData: [],
      isExpand: false,
      shopName: "",
      isCheckShop: true,
      shopList: [],
      shopListClone: [],
      userList: [],
      isExpandUser: false,
      nickName: "",
      isCheckUser: true,
      designVisible: false,
      currentRow: {},
      statRange: "",
    }
  },
  computed: {
    ...mapGetters(["dictData", "dictMap", "user"]),
  },
  created() {
    let curDate = new Date()
    let preDate = new Date(curDate.getTime() - 24 * 60 * 60 * 1000 * 7)

    this.dateTime = [
      this.parseTime(preDate, "{y}-{m}-{d}"),
      this.parseTime(curDate, "{y}-{m}-{d}"),
    ]

    this.weekBegin = this.parseTime(curDate, "{y}-{m}-{d}")
    this.weekEnd = this.parseTime(curDate, "{y}-{m}-{d}")
    this.monthBegin = this.parseTime(curDate, "{y}-{m}-{d}")
    this.monthEnd = this.parseTime(curDate, "{y}-{m}-{d}")
    this.loadData()
    this.getShops()
    this.getUserList()
  },
  methods: {
    loadData() {
      this.startLoading()
      this.statRange = this.form.statRange
      let params = Object.assign({}, this.form)
      if (this.dateTime && this.dateTime.length > 0) {
        params.beginTime = this.dateTime[0]
        params.endTime = this.dateTime[1]

        this.form.beginTime = this.dateTime[0]
        this.form.endTime = this.dateTime[1]
      } else {
        params.beginTime = undefined
        params.endTime = undefined
      }

      if (!(params.beginTime && params.endTime)) {
        this.msgError("请输入统计时间")
        this.endLoading()
        return
      }

      let loadMethod =
        params.statRange == "product"
          ? selectGldStatByPro
          : selectGldStatByAcount
      loadMethod(params)
        .then((response) => {
          this.tableData = response.rows
          this.total = response.total
          this.endLoading()
        })
        .catch(() => {
          this.endLoading()
        })
    },
    async handleShowDetail(row) {
      let loadMethod =
        this.form.statRange == "product"
          ? selectGldStatByProDetail
          : selectGldStatByAcountDetail
      this.currentRow = row

      let params = Object.assign({}, this.form)
      if (this.dateTime.length > 0) {
        params.beginTime = this.dateTime[0]
        params.endTime = this.dateTime[1]
      } else {
        params.beginTime = undefined
        params.endTime = undefined
      }

      params.pOperNo = row.pOperNo
      params.pId = row.pId
      delete params.operNos

      let result = await loadMethod(params)
      this.detailData = result.rows
      this.designVisible = true
    },
    handleChangeOper() {
      let shopList = this._.clone(this.shopListClone)
      this.shopList = shopList.filter((shop) => {
        if (this.form.operNos.includes(this.user.name)) {
          return true
        }
        for (let record of this.userList) {
          if (this.form.operNos.includes(record.userName)) {
            if (record.shops) {
              for (let item of record.shops) {
                if (item.shopId == shop.shopId) {
                  return true
                }
              }
            }
          }
        }
        return false
      })
      if (this.form.operNos.length == 0 && this.isCheckUser) {
        this.shopList = this._.clone(this.shopListClone)
      }
      this.form.shopIds = []
    },
    getUserList() {
      listMainChild({}).then((res) => {
        this.userList = res.rows
      })
    },

    resetForm() {
      this.form = {
        pageNum: 1,
        pageSize: 10,
        operNos: [],
        beginTime: undefined,
        endTime: undefined,
        statType: "",
        statRange: "account",
      }
      let curDate = new Date()
      let preDate = new Date(curDate.getTime() - 24 * 60 * 60 * 1000 * 7)

      this.dateTime = [
        this.parseTime(preDate, "{y}-{m}-{d}"),
        this.parseTime(curDate, "{y}-{m}-{d}"),
      ]
    },

    /**导出 */
    handleExport() {
      if (this.form.time) {
        this.form.beginTime = this.form.time[0]
        this.form.endTime = this.form.time[1]
      } else {
        this.form.beginTime = undefined
        this.form.endTime = undefined
      }
      let params = Object.assign({}, this.form)
      delete params["time"]
      delete params["pageSize"]
      delete params["pageNum"]
      downLoadExcel(
        `/money/fund/export?${qs.stringify(this.form)}&fileName=` +
          Math.random(),
        Math.random()
      )
    },
    getShops() {
      getShopList().then((res) => {
        this.shopList = res.rows
        this.shopListClone = this._.clone(res.rows)
        this.$nextTick(() => {
          this.scrollMenu = document.querySelector(".table-menu")
          this.objectHeight = this.scrollMenu.offsetTop
          window.addEventListener("scroll", this.handleScroll)
        })
        // this.handleChangeShop()
        // res.rows.map(()=>{})
      })
    },
    handleChangeShop() {
      this.form.shopIds = []
      if (this.isCheckShop) {
        this.shopList.map((record) => {
          this.form.shopIds.push(record.shopId)
        })
      }
    },
    handleChangeUser() {
      this.form.operNos = []
      let shopList = this._.clone(this.shopListClone)
      if (this.isCheckUser) {
        this.userList.map((record) => {
          this.form.operNos.push(record.userName)
        })
        this.shopList = shopList
      } else {
        this.shopList = []
      }
      this.form.shopIds = []
    },
  },
}
</script>
<style lang="scss" scoped>
.btn-bar-right {
  text-align: right;
}
</style>
